// GoogleAuth.js
import {useState} from "react";
import "./Login.css";
import {useNavigate} from "react-router-dom";
import {auth, provider, signInWithPopup, signOut} from "../../firebaseConfig";

const Login = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const handleSignIn = async () => {
        try {
        const result = await signInWithPopup(auth, provider);
        if (result.user) {
        let response = await fetch(`${process.env.REACT_APP_NODEURL}/checkUser`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',
            body: JSON.stringify({email: result._tokenResponse.email}),
        });
        let ans = await response.json();
        if (ans.res == "Not Found") {
            let res = await fetch(`${process.env.REACT_APP_NODEURL}/createUser`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: result._tokenResponse.email,
                    firstName: result._tokenResponse.firstName,
                    lastName: result._tokenResponse.lastName,
                    photoUrl: result._tokenResponse.photoUrl,
                }),
            });
            let ans = await res.json();
            navigate("/dashboard");
        } else {
            console.log("ahh");
            navigate("/dashboard");
        }

        } 
    }catch (error) {
            console.error("Google Sign-In Error:", error);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2 className="auth-title">My Planner</h2>
                <p className="auth-text">AI-powered planning for a smarter day.</p>
                <button className="auth-button" onClick={handleSignIn}>
                    Sign in with Google
                </button>
            </div>
        </div>
    );
};

export default Login;
